import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import './HomePage.css';

export function HomePage() {
  const navigate = useNavigate();
  const [matchId, setMatchId] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (matchId.trim()) {
      navigate(`/match/${matchId.trim()}`);
    }
  };

  return (
    <div className="home-page">
      <div className="container">
        <div className="home-content">
          <div className="home-header">
            <div>
              <h1 className="home-title">clickpong</h1>
              <p className="home-subtitle">
                Acompanhamento moderno de partidas de tênis de mesa em tempo real
              </p>
            </div>
            <Button 
              variant="secondary" 
              onClick={() => navigate('/admin/tables')}
              className="admin-button"
            >
              ⚙️ Admin
            </Button>
          </div>

          <Card className="home-card">
            <form onSubmit={handleSubmit} className="match-id-form">
              <label htmlFor="matchId" className="form-label">
                ID da Partida
              </label>
              <input
                id="matchId"
                type="text"
                value={matchId}
                onChange={(e) => setMatchId(e.target.value)}
                placeholder="Digite o ID da partida"
                className="form-input"
                required
              />
              <Button type="submit" size="lg" className="submit-button">
                Acessar Partida
              </Button>
            </form>
          </Card>

          <div className="home-features">
            <div className="feature">
              <div className="feature-icon">🏓</div>
              <h3>Tempo Real</h3>
              <p>Acompanhe pontos e sets atualizados instantaneamente</p>
            </div>
            <div className="feature">
              <div className="feature-icon">📱</div>
              <h3>PWA</h3>
              <p>Funciona offline e pode ser instalado no seu dispositivo</p>
            </div>
            <div className="feature">
              <div className="feature-icon">✨</div>
              <h3>Design Moderno</h3>
              <p>Interface elegante com glassmorphism e animações suaves</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
